import script from "./SalesMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesMenu.vue?vue&type=script&setup=true&lang=js"

import "./SalesMenu.vue?vue&type=style&index=0&id=d08bffd8&lang=scss"

const __exports__ = script;

export default __exports__